import React, { useEffect, useState } from "react";
import Header from "../component/menu/Header";
import { constants } from "../constant/constants";
import CustomInput from "../component/CustomInput";
import CopyrightComponent from "../component/CopyrightComponent";
import { useNavigate } from "react-router-dom";
import ApiService from "../utils/ApiService";
import useUserStore from "../stores/store";
import CustomLoader from "../component/menu/CustomLoader";
import { Input } from "antd";

function ChangePassword() {
  const { showNotification, user, setUser, clearUser } = useUserStore();

  const navigate = useNavigate();
  const [formPosition, setFormPosition] = useState({
    marginTop: "50px",
  });

  // State to store form input values
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  // State for error/success messages
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const clearFields = () => {
    setOldPassword("")
    setNewPassword("")
    setConfirmPassword("")
  }

  // Handle form submission
  const handleChangePassword = async () => {
    // Validation checks
    if (!oldPassword || !newPassword || !confirmPassword) {
      setMessage("Please fill in all fields.");
      return;
    }
    if (newPassword !== confirmPassword) {
      setMessage("New password and confirm password do not match.");
      return;
    }

    // Prepare params for API call
    const params = {
      password: oldPassword,
      newPassword: newPassword,
      confirmPassword: confirmPassword,
    };

    try {
      setIsLoading(true);
      setMessage(""); // Reset any previous message
      const result = await ApiService.CHANGE_PASSWORD(params, user.token.token);

      if (result.error) {
        setMessage(result.message); // Display error message
      } else {
        showNotification("Password changed successfully!", false);
        navigate("/")
      }
      clearFields();
    } catch (error) {
      setMessage("An error occurred while changing the password.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex flex-col">
      <CustomLoader/>
      <Header title={`McDonalds Food Chain`} />
      <div className="flex flex-col p-[24px] w-full mt-[80px] font-uregular ">
        <div className="flex flex-col items-center rounded ">
          <div
            id="login-form"
            style={formPosition}
            className="flex w-[360px] flex-col lg:w-[400px] bg-white justify-center rounded-[5px] p-[20px] border-2"
          >
            <div className="w-full h-[60px] flex flex-row mb-[15px] items-center justify-start gap-x-[5%]">
                    <img className="w-auto h-full" src={`/images/icons/TableTap_icon.svg`}/>
                    <div className="w-auto h-full content-center">
                        <img src={`/images/Scan_Order_Savor.png`}/>
                    </div>
                </div>

            {message?<div className="mx-[20px] font-ubold mb-[12px] text-pink text-sm">{message}</div>:''}
            {/* Form Fields */}
            <div className="w-full flex flex-col px-[16px] mb-[12px]">
              <div class="text-sm flex flex-row font-uregular">
                <div>Old Password</div>
                <div class="font-ubold text-red-700 ml-[2px]">*</div>
              </div>
              
              <Input.Password
                placeholder="Write current password"
                onChange={e => setOldPassword(e.target.value)}
                required={true}
                onPressEnter={handleChangePassword}
                value={oldPassword}
                className="h-[34px] font-uregular"
              />
            </div>
            <div className="w-full flex flex-col px-[16px] mb-[12px]">
              <div class="text-sm flex flex-row font-uregular">
                <div>New Password</div>
                <div class="font-ubold text-red-700 ml-[2px]">*</div>
              </div>
              
              <Input.Password
                placeholder="Write new password"
                onChange={e => setNewPassword(e.target.value)}
                required={true}
                onPressEnter={handleChangePassword}
                value={newPassword}
                className="h-[34px] font-uregular"
              />
            </div>
            <div className="w-full flex flex-col px-[16px] mb-[12px]">
              <div class="text-sm flex flex-row font-uregular">
                <div>Confirm Password</div>
                <div class="font-ubold text-red-700 ml-[2px]">*</div>
              </div>
              
              <Input.Password
                placeholder="Write new password"
                onChange={e => setConfirmPassword(e.target.value)}
                required={true}
                onPressEnter={handleChangePassword}
                value={confirmPassword}
                className="h-[34px] font-uregular"
              />
            </div>

            {/* Change Password Button */}
            <div className="flex flex-row px-[16px] mt-[8px]">
              <div
                className={`bg-yellow text-black px-[12px] py-[8px] rounded-[5px] font-ubold cursor-pointer ${
                  isLoading ? "opacity-50" : ""
                }`}
                onClick={handleChangePassword}
                disabled={isLoading}
              >
                {isLoading ? "Changing..." : "Change"}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChangePassword;
